import * as Sentry from "@sentry/react";
import { HydratedRouter } from "react-router/dom";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

// Browser error reporting. Gated on a client DSN plumbed through window.ENV by
// the root loader (see root.jsx). Only the public client DSN is exposed here —
// never the server DSN or the source-map auth token.
if (typeof window !== "undefined" && window.ENV?.SENTRY_DSN_CLIENT) {
  Sentry.init({
    dsn: window.ENV.SENTRY_DSN_CLIENT,
    environment: window.ENV.SENTRY_ENVIRONMENT || "production",
    release: window.ENV.APP_VERSION || undefined,
    tracesSampleRate: 0, // Bugsink is errors-only — keep at 0.
    // Predictable, non-actionable noise from embedded admin apps + App Bridge.
    // Keep conservative so real bugs are never masked.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "Non-Error promise rejection captured",
      /AbortError/,
      /Failed to fetch/i,
      /Load failed/i,
    ],
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  );
});
